import {useFormUpdaterContext} from "../context/FormUpdaterContext/Consumer";

export default function useFormUpdater() {
    return useFormUpdaterContext()
}